import { useLocalStorage } from '@/hooks/useLocalStorage';

export const useSidebar = () => useLocalStorage('sidebar', true);
